<template>
  <div id="buyerManagePostsPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-photo-film fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">افزودن پست</span>
                </div>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="definePostTab ? 'profile-active-tab':''" class="pointer" @click="showDefinePostTab">تعریف پست</span>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="listPostsTab ? 'profile-active-tab':''" class="pointer" @click="showListPostsTab">لیست پست ها</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="definePostTab" class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row">
              <div class="col-12">
                <i class="fa-solid fa-period mr-3"></i> عکس یا فیلم پست خود را وارد کنید
                <div
                    dir="ltr">
                  <carousel
                      :autoplay="false"
                      :autoplayTimeout="6000"
                      :dots="false"
                      :loop="false"
                      :margin="5"
                      :nav="false"
                      :responsive="{0:{items:3,margin:1},400:{items:4,margin:1},540:{items:5,margin:1},630:{items:5,margin:1},768:{items:3,margin:1},1200:{items:5,margin:1},}"
                      class="py-1 text-center">
                    <div v-for="i in 10" :key="i" class="row">
                      <div class="col-12">
                        <input v-show="false" :id="i" accept=".jpg,.jpeg.,.gif,.png,.mov,.mp4" type="file"
                               @change="attachmentSelected($event,i)"/>
                        <div :id="'image'+i"
                             class="bg-white rounded-lg d-flex justify-content-center  post-preview-image align-items-center text-center">
                          <i v-if="!hasPhoto[i]" class="fas fa-circle-plus fa-xl pointer"
                             @click="openUploadFile(i)"></i>
                          <i v-else class="fas fa-circle-xmark white--text fa-xl pointer" @click="removeFile(i)"></i>
                        </div>
                      </div>
                    </div>
                  </carousel>
                </div>
              </div>
              <div class="col-12 pt-0">
                <i class="fa-solid fa-period mr-3"></i> عکس کاور پست خود را وارد کنید *

                <input v-show="false" ref="inputUpload" accept=".jpg,.jpeg.,.gif,.png" type="file"
                       @change="coverAttachmentSelected"/>
                <div id="coverImage"
                     class="bg-white rounded-lg d-flex justify-content-center mr-auto ml-1  post-preview-image align-items-center text-center">
                  <i v-if="!hasCoverPhoto" class="fas fa-circle-plus fa-xl pointer"
                     @click="$refs.inputUpload.click()"></i>
                  <i v-else class="fas fa-circle-xmark white--text fa-xl pointer" @click="removeCoverPhoto()"></i>
                </div>
              </div>
              <div class="col-12">
                <i class="fa-solid fa-period mr-3"></i>کپشن یا توضیحات پست
                <editor-content :editor="captionEditor" class="text-editor mt-2"/>
              </div>
              <div class="col-12">
                <i class="fa-solid fa-period mr-3 "></i>هشتگ مرتبط با پست خود را وارد کنید
                <v-combobox
                    v-model="chips"
                    :items="hashtagsList"
                    :search-input.sync="search"
                    class="mt-2 selected-hashtags"
                    clearable
                    flat
                    hide-selected
                    multiple
                    solo
                    @change="showChips($event)"
                    @click:clear="comboboxClearSelected"
                >

                </v-combobox>
                <v-chip
                    v-for="(item,i) in hashtags"
                    :key="i"
                    :input-value="item"
                    class="m-1"
                    close
                    color="primary"
                    outlined
                    @click:close="remove(item)">
                  <span>#</span>
                  <strong>{{ item }}</strong>
                </v-chip>
              </div>
              <div class="col-12">
                <i class="fa-solid fa-period mr-3 "></i> محصول یا محصولات مرتبط با پست خود را انتخاب کنید
                <div class="font12px p-1 grey--text mt-2">
                  اگر پست شما ارتباطی با محصولی دارد میتوانید محصول را از باکس زیر انتخاب کنید.
                </div>
                <div class="font12px p-1 grey--text pt-0">
                  لینک محصول باید از سایت ایوان خانه باشد و از سایت دیگر نمیتواند باشد
                </div>

                <v-autocomplete
                    v-model="productSelectedList"
                    :cache-items="true"
                    :items="productList"
                    chips
                    deletable-chips
                    flat
                    hide-details
                    item-text="Name"
                    item-value="VendorProductID"
                    multiple
                    placeholder="وارد نمایید"
                    solo>
                </v-autocomplete>
              </div>
              <div class="col-12">
                <i class="fa-solid fa-period mr-3 "></i>لوکیشن مرتبط به پست خود را وارد کنید
                <div v-if="markers[0] !== undefined" class="my-2">
                  <GmapAutocomplete id="autocomplete"
                                    :position.sync="markers[0].position" class="gMapInput" @place_changed="setPlace"/>
                </div>
                <div class="position-relative">
                  <v-btn class="loc-btn-define-post" icon @click="getCurrentLocation">
                    <i class="fas fa-location  white--text "></i>
                  </v-btn>
                  <GmapMap
                      ref="mapRef"
                      :center="myCoordinates"
                      :options='{ fullscreenControl: false, mapTypeControl: false }'
                      :zoom="zoom"
                      class="rounded-lg"
                      style="height:500px"
                      @click="mark"
                  >

                    <GmapMarker
                        v-for='(marker,index) in markers'
                        :key="index"
                        :animation="2"
                        :clickable="true"
                        :position="marker"
                        @click="center=marker"/>
                  </GmapMap>
                </div>
              </div>
              <div class="col-12">
                <v-btn block color="primary" @click="definePost">
                  انتشار پست
                </v-btn>
              </div>

            </div>


          </div>

        </div>
        <div v-if="listPostsTab" class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row">
              <div v-if="postsItems.length <= 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  هنوز پستی ثبت نشده است
                </div>
              </div>
              <div v-else class="col-12">
                <div class="row">
                  <div class="col pt-0 ">
                    <v-autocomplete
                        v-model="searchKeyWord"
                        :items="hashtagsItems"
                        append-icon="far fa-magnifying-glass"
                        class="rounded-lg search-combobox"
                        clearable
                        dense
                        placeholder="..Search Hashtag"
                        flat
                        hide-details
                        item-text="Content"
                        item-value="HashTagID"
                        solo
                        @keyup="searchInPostList"
                        @change="searchInPostList"
                        @click:clear="removeSearchHistory">
                    </v-autocomplete>
                  </div>
                </div>
                <div v-if="!hasResult" class="col-12 text-center">
                  نتیجه ای یافت نشد
                </div>
                <masonry
                    v-else
                    id="postGalley"
                    :cols="{default: 3, 1150:2, 700: 2}">
                  <div v-for="(item,i) in postsItems" :key="i"

                       class="p-1 mx-auto d-block">
                    <v-img :src="$replaceHttps(item.FileCoverUrl)" class=" rounded-11px">

                      <div class="p-2">
                        <div v-if="item.TypeStrucGallery ===2"><i
                            class="fa-solid fa-play  white--text fa-lg shadow-lg"></i></div>
                        <div v-if="item.TypeStrucGallery ===1"><i
                            class="fa-solid fa-images white--text fa-lg shadow"></i></div>

                      </div>
                      <div class="rounded-11px text-center white--text py-2 detail-on-post  col-9 ">
                        <div>
                          <i v-if="item.IsActive" class="white--text fa-xl fa-regular fa-eye ml-3 pointer"
                             @click="changeActivePost(item.VendorSocialNetworkID,item)"></i>
                          <i v-else class="white--text fa-xl fa-regular fa-eye-slash ml-3 pointer"
                             @click="changeActivePost(item.VendorSocialNetworkID,item)"></i>
                          <span class="mr-3">{{ item.CountLike }}</span>like
                        </div>
                        <div class="mt-3"><i class="white--text  fa-xl fa-regular fa-pen ml-3 pointer"
                                             @click="getEditPostData(item.VendorSocialNetworkID)"></i> <span
                            class="mr-3">{{
                            item.CountVisit
                          }}</span>view
                        </div>
                      </div>
                    </v-img>
                  </div>
                </masonry>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
        v-model="editDialog"
        fullscreen
        hide-overlay
        scrollable
        transition="dialog-bottom-transition">
      <v-card class="p-3 dialog-background-color text-right ">
        <v-toolbar
            color="primary"
            dark
            height="56">
          <v-btn
              icon
              @click="closeEditDialog">
            <i class="fas fa-circle-xmark white--text fa-2x"></i>
          </v-btn>
          <v-toolbar-title>
            <span>ویرایش</span></v-toolbar-title>
        </v-toolbar>
        <v-divider class="m-0 pt-5"></v-divider>
        <v-card-text class="px-0">
          <div class="col-12 font-weight-bold">
            <i class="fa-solid fa-period mr-3"></i> عکس یا فیلم پست خود را وارد کنید
            <div
                dir="ltr">
              <carousel
                  v-if="isGalleryLoaded &&editPostFiles.length >0"
                  :autoplay="false"
                  :autoplayTimeout="6000"
                  :dots="false"
                  :loop="false"
                  :margin="5"
                  :nav="false"
                  :responsive="{0:{items:3,margin:1},600:{items:5,margin:1},900:{items:7,margin:1},1200:{items:10,margin:1}}"
                  class="py-1 text-center">
                <div v-for="i in 10" :key="i" class="row">
                  <div class="col-12">
                    <input v-show="false"
                           :id="i"
                           accept=".jpg,.jpeg.,.gif,.png,.mov,.mp4" type="file"
                           @change="attachmentSelectedEdit($event,i)"/>
                    <div
                        v-if="editPostFiles[i-1].type === 1"
                        :id="'imageEdit'+i"
                        :style="'background-image:url('+editPostFiles[i-1].src+')'"
                        class="bg-white rounded-lg d-flex justify-content-center border post-preview-image align-items-center text-center">
                      <i v-if="!editHasPhoto[i]" class="fas fa-circle-plus fa-xl pointer"
                         @click="openUploadFileEdit(i)"></i>
                      <i v-else class="fas fa-circle-xmark  fa-xl pointer" @click="removeFileEdit(i)"></i>

                    </div>
                    <div
                        v-else-if="editPostFiles[i-1].type === 2"
                        :id="'imageEdit'+i"
                        class="bg-white rounded-lg position-relative d-flex justify-content-center border post-preview-image align-items-center text-center overflow-hidden">
                      <video style="width: 100%" @loadeddata="videoLoaded">
                        <source :src="editPostFiles[i-1].src ">
                      </video>
                      <div class="position-absolute">
                        <i v-if="!editHasPhoto[i]" class="fas fa-circle-plus fa-xl pointer"
                           @click="openUploadFileEdit(i)"></i>
                        <i v-else class="fas fa-circle-xmark  fa-xl pointer" @click="removeFileEdit(i)"></i>
                      </div>
                    </div>
                    <div
                        v-else
                        :id="'imageEdit'+i"
                        class="bg-white rounded-lg d-flex justify-content-center border post-preview-image align-items-center text-center">
                      <i v-if="!editHasPhoto[i]" class="fas fa-circle-plus fa-xl pointer"
                         @click="openUploadFileEdit(i)"></i>
                      <i v-else class="fas fa-circle-xmark  fa-xl pointer" @click="removeFileEdit(i)"></i>
                    </div>

                  </div>

                </div>
              </carousel>
            </div>
          </div>
          <div class="col-12 pt-0">
            <i class="fa-solid fa-period mr-3"></i> عکس کاور پست خود را وارد کنید *

            <input v-show="false" ref="inputUpload" accept=".jpg,.jpeg.,.gif,.png" type="file"
                   @change="coverEditAttachmentSelected"/>
            <div v-if="coverEditImage !== null"
                 id="coverEditImageID1"
                 :style="'background-image:url('+coverEditImage+')'"
                 class="bg-white rounded-lg d-flex justify-content-center mr-auto ml-1  post-preview-image align-items-center text-center border ">
              <i v-if="!hasEditCoverPhoto" class="fas fa-circle-plus fa-xl pointer"
                 @click="$refs.inputUpload.click()"></i>
              <i v-else class="fas fa-circle-xmark  fa-xl pointer" @click="removeEditCoverPhoto(1)"></i>
            </div>
            <div v-else
                 id="coverEditImageID2"
                 class="bg-white rounded-lg d-flex justify-content-center mr-auto ml-1  post-preview-image align-items-center text-center border ">
              <i v-if="!hasEditCoverPhoto" class="fas fa-circle-plus fa-xl pointer"
                 @click="$refs.inputUpload.click()"></i>
              <i v-else class="fas fa-circle-xmark  fa-xl pointer" @click="removeEditCoverPhoto(2)"></i>
            </div>
          </div>
          <div class="col-12">
            <i class="fa-solid fa-period mr-3"></i>کپشن یا توضیحات پست
            <editor-content :editor="editCaptionEditor" class="text-editor-edit-dialog mt-2"/>
          </div>
          <div class="col-12">
            <i class="fa-solid fa-period mr-3 "></i>هشتگ مرتبط با پست خود را وارد کنید
            <v-combobox
                v-model="editChips"
                :items="editHashtagsList"
                :search-input.sync="searchEdit"
                background-color="secondary"
                class="mt-2 selected-hashtags"
                clearable
                flat
                hide-selected
                multiple
                solo
                @change="showEditChips($event)"
                @click:clear="editComboboxClearSelected"
            >

            </v-combobox>
            <v-chip
                v-for="(item,i) in editHashtags"
                :key="i"
                :input-value="item"
                class="m-1"
                close
                color="primary"
                outlined
                @click:close="removeEdit(item)">
              <span>#</span>
              <strong>{{ item }}</strong>
            </v-chip>
          </div>
          <div class="col-12">
            <i class="fa-solid fa-period mr-3 "></i> محصول یا محصولات مرتبط با پست خود را انتخاب کنید
            <div class="font12px p-1 grey--text mt-2">
              اگر پست شما ارتباطی با محصولی دارد میتوانید محصول را از باکس زیر انتخاب کنید.
            </div>
            <div class="font12px p-1 grey--text pt-0">
              لینک محصول باید از سایت ایوان خانه باشد و از سایت دیگر نمیتواند باشد
            </div>

            <v-autocomplete
                v-model="editProductSelectedList"
                :cache-items="true"
                :items="productList"
                background-color="secondary"
                chips
                deletable-chips
                flat
                hide-details
                item-text="Name"
                item-value="VendorProductID"
                multiple
                placeholder="وارد نمایید"
                solo>
            </v-autocomplete>
          </div>
          <div class="col-12">
            <i class="fa-solid fa-period mr-3 "></i>لوکیشن مرتبط به پست خود را وارد کنید
            <div v-if="markers[0] !== undefined" class="my-2">
              <GmapAutocomplete id="editMapAutoComplete"
                                :position.sync="markers[0].position" class="gMapInputEdit" @place_changed="setPlace"/>
            </div>
            <div class="position-relative">
              <v-btn class="loc-btn-define-post" icon @click="getCurrentLocation">
                <i class="fas fa-location  white--text "></i>
              </v-btn>
              <GmapMap
                  ref="mapRef"
                  :center="myCoordinates"
                  :options='{ fullscreenControl: false, mapTypeControl: false }'
                  :zoom="zoom"
                  class="rounded-lg"
                  style="height:500px"
                  @click="mark"
              >

                <GmapMarker
                    v-for='(marker,index) in markers'
                    :key="index"
                    :animation="2"
                    :clickable="true"
                    :position="marker"
                    @click="center=marker"/>
              </GmapMap>
            </div>
          </div>
          <div class="col-12">
            <v-btn :disabled="loading" :loading="loading" block color="primary"
                   @click="editPost">
              ویرایش پست
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import BackBar from "@/components/BackBar";
import carousel from "vue-owl-carousel";
import {Editor, EditorContent} from 'tiptap';


export default {
  name: "BuyerManagePosts",
  metaInfo: {
    title: 'ایوان خانه- افزودن پست',
  },
  components: {BackBar, carousel, EditorContent},
  data: () => ({
    listPostsTab: false,
    loading: false,
    definePostTab: true,
    posts: [],
    hasPhoto: {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: false},
    editHasPhoto: {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: false},
    hasCoverPhoto: false,
    selectedImageCoverFilePath: null,
    captionEditor: null,
    caption: '',
    chips: [],
    editHashtagsList: [],
    editChips: [],
    items: [],
    hashtags: [],
    editHashtags: [],
    map: null,
    markers: [],
    myCoordinates: {
      lat: 35.723524,
      lng: 51.396660
    },
    zoom: 10,
    postsItems: [],
    selectedFileObjects: {},
    selectedFileType: {},
    productList: [],
    hashtagsList: [],
    productSelectedList: [],
    editProductSelectedList: [],
    search: null,
    searchEdit: null,
    description: null,
    locationName: null,
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    editDialog: false,
    isEditDataLoaded: false,
    isGalleryLoaded: false,
    editPostFiles: [],
    selectedFileObjectsEdit: {},
    selectedFileTypeEdit: {},
    isMediaChanged: false,
    selectedImageCoverEditFilePath: null,
    hasEditCoverPhoto: false,
    coverEditImage: null,
    editCaptionEditor: null,
    editIsActive: null,
    allHashtags: [],
    typeVendorSocialNetworkStatus: null,
    vendorSocialNetworkID: null,
    searchKeyWord: '',
    allPostList: [],
    hashtagsItems: [],
    hasResult: true

  }),

  created() {
    this.$getLocation({})
        .then(coordinates => {
          this.myCoordinates = coordinates;
          this.markers.push(this.myCoordinates)
        })
        .catch(error => console.log(error));
  },
  mounted() {
    _this = this
    this.captionEditor = new Editor({
      content: this.caption,
    })
    this.getDefinePostData()
    this.getProductList()
    this.getPosts()

  },
  methods: {
    showDefinePostTab() {
      this.definePostTab = true;
      this.listPostsTab = false
    },
    showListPostsTab() {
      this.definePostTab = false;
      this.listPostsTab = true
    },
    attachmentSelected(e, i) {
      let files = e.target.files;
      if (files.length > 0) {

        this.hasPhoto[i] = true;

        let file = event.target.files[0];
        let fileReader = new FileReader();
        this.selectedFileObjects[i] = file
        if (file.type.match('image')) {
          fileReader.onload = function () {
            document.getElementById('image' + i).style.backgroundImage = "url(" + fileReader.result + ")"
            _this.selectedFileType[i] = 1
          };
          fileReader.readAsDataURL(file);
        } else {
          try {
            fileReader.onload = function () {
              let blob = new Blob([fileReader.result], {type: file.type});
              let url = URL.createObjectURL(blob);
              let video = document.createElement('video');

              _this.selectedFileType[i] = 2
              let timeupdate = function () {
                if (_this.snapImage(url, video, i)) {
                  video.removeEventListener('timeupdate', timeupdate);
                  video.pause();
                }
              };
              video.addEventListener('loadeddata', function () {
                if (_this.snapImage(url, video, i)) {
                  video.removeEventListener('timeupdate', timeupdate);
                }
              });

              video.addEventListener('timeupdate', timeupdate);
              video.preload = 'metadata';
              video.src = url;
              video.muted = true;
              video.playsInline = true;
              video.play();
            };
            fileReader.readAsArrayBuffer(file);
          } catch (e) {
            console.log(e)
          }

        }
      }


    },
    snapImage(url, video, i) {
      let canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      let image = canvas.toDataURL();
      let success = image.length > 100000;
      if (success) {
        document.getElementById('image' + i).style.backgroundImage = "url(" + image + ")"
        // URL.revokeObjectURL(url);
      }
      return success;
    },
    openUploadFile(i) {
      document.getElementById(i).click()
    },
    removeFile(i) {
      document.getElementById('image' + i).style.backgroundImage = ""
      this.hasPhoto[i] = false;
    },
    coverAttachmentSelected(e) {
      let files = e.target.files;
      if (files.length > 0) {
        this.hasCoverPhoto = true
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          document.getElementById('coverImage').style.backgroundImage = "url(" + fr.result + ")"
          this.selectedImageCoverFilePath = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.hasCoverPhoto = false;
      }
    },
    removeCoverPhoto() {
      document.getElementById('coverImage').style.backgroundImage = ""

      this.hasCoverPhoto = false
    },
    remove(item) {
      this.hashtags.splice(this.hashtags.indexOf(item), 1)
      this.chips.splice(this.hashtags.indexOf(item), 1)
      this.chips = [...this.chips]
      this.hashtags = [...this.hashtags]
    },
    removeEdit(item) {
      this.editHashtags.splice(this.editHashtags.indexOf(item), 1)
      this.editChips.splice(this.editHashtags.indexOf(item), 1)
      this.editChips = [...this.editChips]
      this.editHashtags = [...this.editHashtags]
    },
    showChips() {
      this.hashtags = this.chips
      // this.chips = null
    },
    comboboxClearSelected() {
      this.hashtags = []
      this.chips = []
    },
    editComboboxClearSelected() {
      this.editHashtags = []
      this.editChips = []
    },
    mark(event) {
      if (this.markers.length > 0) {
        this.markers.pop()
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      } else {
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      }
    },
    getCurrentLocation() {
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinates = coordinates;
            if (this.markers.length > 0) {
              this.markers.pop()
              this.markers.push(this.myCoordinates)
              this.$refs.mapRef.$mapPromise.then(map => map.panTo(coordinates));

            } else {
              this.markers.push(this.myCoordinates)
            }
          })
          .catch(error => console.log(error));
    },
    setPlace(event) {
      this.myCoordinates = {
        lat: event.geometry.location.lat(),
        lng: event.geometry.location.lng()
      };
      this.markers = [];
      this.markers.push(this.myCoordinates)
      this.locationName = event.name;
    },
    getDefinePostData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);


      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/_Define", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.hashtagsList = json.HashTagsList
          })
          .catch(error => console.log('error', error));
    },
    getProductList() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Shopping/GetActiveProducts", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.productList = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    definePost() {
      if (this.hasCoverPhoto) {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("ImageFileCoverUrl", this.selectedImageCoverFilePath);
        formdata.append("TypeVendorSocialNetworkStatus", "1");
        formdata.append("VendorID", "");
        formdata.append("FileCoverUrl", "");
        formdata.append("IsActive", "true");
        formdata.append("Description", this.captionEditor.getHTML());
        if (this.selectedFileObjects[1] !== undefined) {
          formdata.append("ImageFileUrl", this.selectedFileObjects[1]);
          formdata.append("TypeStrucGallery", this.selectedFileType[1]);
        }
        if (this.selectedFileObjects[2] !== undefined) {
          formdata.append("ImageFileUrl2", this.selectedFileObjects[2]);
          formdata.append("FileType2", this.selectedFileType[2]);
        }
        if (this.selectedFileObjects[3] !== undefined) {
          formdata.append("ImageFileUrl3", this.selectedFileObjects[3]);
          formdata.append("FileType3", this.selectedFileType[3]);
        }
        if (this.selectedFileObjects[4] !== undefined) {
          formdata.append("ImageFileUrl4", this.selectedFileObjects[4]);
          formdata.append("FileType4", this.selectedFileType[4]);
        }
        if (this.selectedFileObjects[5] !== undefined) {
          formdata.append("ImageFileUrl5", this.selectedFileObjects[5]);
          formdata.append("FileType5", this.selectedFileType[5]);
        }
        if (this.selectedFileObjects[6] !== undefined) {
          formdata.append("ImageFileUrl6", this.selectedFileObjects[6]);
          formdata.append("FileType6", this.selectedFileType[6]);
        }
        if (this.selectedFileObjects[7] !== undefined) {
          formdata.append("ImageFileUrl7", this.selectedFileObjects[7]);
          formdata.append("FileType7", this.selectedFileType[7]);
        }
        if (this.selectedFileObjects[8] !== undefined) {
          formdata.append("ImageFileUrl8", this.selectedFileObjects[8]);
          formdata.append("FileType8", this.selectedFileType[8]);
        }
        if (this.selectedFileObjects[9] !== undefined) {
          formdata.append("ImageFileUrl9", this.selectedFileObjects[9]);
          formdata.append("FileType9", this.selectedFileType[9]);
        }
        if (this.selectedFileObjects[10] !== undefined) {
          formdata.append("ImageFileUrl10", this.selectedFileObjects[10]);
          formdata.append("FileType10", this.selectedFileType[10]);
        }
        formdata.append("Latitude", this.markers[0].lat);
        formdata.append("Longitude", this.markers[0].lng);
        formdata.append("LocationTitle", this.locationName);
        let tags = this.hashtags
        for (let i = 0; i < tags.length; i++) {
          formdata.append("SelectedHashTags[" + i + "]", tags[i]);
        }

        let productsId = this.productSelectedList
        for (let i = 0; i < productsId.length; i++) {
          formdata.append("SelectedProducts[" + i + "]", productsId[i]);
        }

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        let resStatus = null
        fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/_Define", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                this.resultText = JSON.parse(result).Message
                this.removeDefinePostFields()
              } else {
                this.resultText = result
              }
              this.showResult = true
            })
            .catch(error => console.log('error', error));
      } else {
        this.resultText = 'عکس کاور پست خود را وارد کنید'
        this.showResult = true
      }
    },
    getPosts() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.postsItems = json
            this.allPostList = json
            this.showLoaderDialog = false
            let AllPostsHashtags = []
            for (let i = 0; i < json.length; i++) {
              let selectedPostHashtags = json[i].SelectedHashTags
              if(selectedPostHashtags !== null) {
                for (let j = 0; j < selectedPostHashtags.length; j++) {
                  AllPostsHashtags.push(selectedPostHashtags[j])
                }
              }            }
            let postsHashtags = [...new Set(AllPostsHashtags)]
            let allHashtags = this.$store.getters.getHashtags
            let hashtagsItems = []
            for (let i = 0; i < postsHashtags.length; i++) {
              let findHashtag = allHashtags.find(x => x.HashTagID === postsHashtags[i])
              if (findHashtag !== undefined) {
                hashtagsItems.push(findHashtag)
              }
            }
            this.hashtagsItems = hashtagsItems

          })
          .catch(error => console.log('error', error));
    },
    getEditPostData(id) {
      this.showLoaderDialog = true
      this.editCaptionEditor = null
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      this.editPostFiles = []
      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/_Edit?VendorSocialNetworkID=" + id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let postFiles = []
            postFiles.push({src: json.FileUrl, type: json.TypeStrucGallery})
            postFiles.push({src: json.FileUrl2, type: json.FileType2})
            postFiles.push({src: json.FileUrl3, type: json.FileType3})
            postFiles.push({src: json.FileUrl4, type: json.FileType4})
            postFiles.push({src: json.FileUrl5, type: json.FileType5})
            postFiles.push({src: json.FileUrl6, type: json.FileType6})
            postFiles.push({src: json.FileUrl7, type: json.FileType7})
            postFiles.push({src: json.FileUrl8, type: json.FileType8})
            postFiles.push({src: json.FileUrl9, type: json.FileType9})
            postFiles.push({src: json.FileUrl10, type: json.FileType10})
            if (json.FileUrl !== null) {
              this.editHasPhoto[1] = true
            }
            if (json.FileUrl2 !== null) {
              this.editHasPhoto[2] = true
            }
            if (json.FileUrl3 !== null) {
              this.editHasPhoto[3] = true
            }
            if (json.FileUrl4 !== null) {
              this.editHasPhoto[4] = true
            }
            if (json.FileUrl5 !== null) {
              this.editHasPhoto[5] = true
            }
            if (json.FileUrl6 !== null) {
              this.editHasPhoto[6] = true
            }
            if (json.FileUrl7 !== null) {
              this.editHasPhoto[7] = true
            }
            if (json.FileUrl8 !== null) {
              this.editHasPhoto[8] = true
            }
            if (json.FileUrl9 !== null) {
              this.editHasPhoto[9] = true
            }
            if (json.FileUrl10 !== null) {
              this.editHasPhoto[10] = true
            }
            if (json.FileCoverUrl !== null) {
              this.coverEditImage = json.FileCoverUrl
              this.hasEditCoverPhoto = true
            }

            this.editCaptionEditor = new Editor({
              content: json.Description,
            })
            this.vendorSocialNetworkID = json.VendorSocialNetworkID
            this.editChips = []
            this.editHashtags = []
            this.editHashtagsList = json.HashTagsList
            let selectedHashtags = json.SelectedHashTags
            let allHashtags = this.$store.getters.getHashtags
            for (let i = 0; i < selectedHashtags.length; i++) {
              let searchTmp = allHashtags.find(x => x.HashTagID === selectedHashtags[i])
              if (searchTmp !== undefined) {
                this.editHashtags.push(searchTmp.Content)
                this.editChips.push(searchTmp.Content)
              }
            }
            this.editProductSelectedList = json.SelectedProducts
            setTimeout(function () {
              document.getElementById('editMapAutoComplete').value = json.LocationTitle;
            }, 0);
            if (this.markers.length > 0) {
              this.markers.pop()
              this.markers.push({lat: json.Latitude, lng: json.Longitude})
              this.myCoordinates = {lat: json.Latitude, lng: json.Longitude}
            } else {
              this.markers.push({lat: json.Latitude, lng: json.Longitude})
              this.myCoordinates = {lat: json.Latitude, lng: json.Longitude}
            }
            this.showLoaderDialog = false

            this.editDialog = true
            this.isGalleryLoaded = true
            this.isEditDataLoaded = true
            this.editPostFiles = postFiles
            this.editIsActive = json.IsActive
            this.typeVendorSocialNetworkStatus = json.TypeVendorSocialNetworkStatus
          })
          .catch(error => console.log('error', error));
    },
    videoLoaded(e) {
      let videoElem = e.target;
      videoElem.currentTime = 5
      videoElem.pause()

    },
    attachmentSelectedEdit(e, i) {
      let files = e.target.files;
      if (files.length > 0) {
        this.isMediaChanged = true
        this.editHasPhoto[i] = true;

        let file = event.target.files[0];
        _this.selectedFileObjectsEdit[i] = file
        let fileReader = new FileReader();
        if (file.type.match('image')) {
          fileReader.onload = function () {
            document.getElementById('imageEdit' + i).style.backgroundImage = "url(" + fileReader.result + ")"

            _this.selectedFileTypeEdit[i] = 1
          };

          fileReader.readAsDataURL(file);
        } else {
          try {
            fileReader.onload = function () {
              let blob = new Blob([fileReader.result], {type: file.type});
              let url = URL.createObjectURL(blob);
              let video = document.createElement('video');

              _this.selectedFileTypeEdit[i] = 2
              let timeupdate = function () {
                if (_this.snapImageEdit(url, video, i)) {
                  video.removeEventListener('timeupdate', timeupdate);
                  video.pause();
                }
              };
              video.addEventListener('loadeddata', function () {
                if (_this.snapImageEdit(url, video, i)) {
                  video.removeEventListener('timeupdate', timeupdate);
                }
              });

              video.addEventListener('timeupdate', timeupdate);
              video.preload = 'metadata';
              video.src = url;
              video.muted = true;
              video.playsInline = true;
              video.play();
            };
            fileReader.readAsArrayBuffer(file);
          } catch (e) {
            console.log(e)
          }

        }
      }

    },
    snapImageEdit(url, video, i) {
      let canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      let image = canvas.toDataURL();
      let success = image.length > 100000;
      if (success) {
        document.getElementById('imageEdit' + i).style.backgroundImage = "url(" + image + ")"

        // URL.revokeObjectURL(url);
      }
      return success;
    },
    openUploadFileEdit(i) {
      document.getElementById(i).click()
    },
    removeFileEdit(i) {
      document.getElementById('imageEdit' + i).style.backgroundImage = ""
      delete this.selectedFileObjectsEdit[i]
      delete this.selectedFileTypeEdit[i]
      this.editPostFiles[i - 1].src = null
      this.isMediaChanged = true
      this.editHasPhoto[i] = false;
    },
    coverEditAttachmentSelected(e) {
      let files = e.target.files;
      if (files.length > 0) {
        this.coverEditImage = null
        this.hasEditCoverPhoto = true
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.selectedImageCoverEditFilePath = files[0] // this is an image file that can be sent to server...
          document.getElementById('coverEditImageID2').style.backgroundImage = "url(" + fr.result + ")"
        })
      } else {
        this.hasEditCoverPhoto = false;
      }
    },
    removeEditCoverPhoto(id) {
      if (id === 1) {
        document.getElementById('coverEditImageID1').style.backgroundImage = ""
      } else if (id === 2) {
        document.getElementById('coverEditImageID2').style.backgroundImage = ""
      }

      this.hasEditCoverPhoto = false
    },
    showEditChips() {
      this.editHashtags = this.editChips
    },
    editPost() {
      if (this.hasEditCoverPhoto) {
        this.showLoaderDialog = true
        this.loading = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        if (this.selectedImageCoverEditFilePath !== null) {
          formdata.append("ImageFileCoverUrl", this.selectedImageCoverEditFilePath);
        } else {
          formdata.append("FileCoverUrl", this.coverEditImage);
        }
        formdata.append("IsActive", this.editIsActive);
        formdata.append("VendorSocialNetworkID", this.vendorSocialNetworkID);
        // formdata.append("TypeRole", 3);
        formdata.append("TypeVendorSocialNetworkStatus", this.typeVendorSocialNetworkStatus);
        formdata.append("Description", this.editCaptionEditor.getHTML());
        if (this.selectedFileObjectsEdit[1] !== undefined) {
          formdata.append("ImageFileUrl", this.selectedFileObjectsEdit[1]);
          formdata.append("TypeStrucGallery", this.selectedFileTypeEdit[1]);
        } else {
          formdata.append("FileUrl", this.editPostFiles[0].src);
          formdata.append("TypeStrucGallery", this.editPostFiles[0].type);
        }

        for (let i = 2; i <= 10; i++) {
          if (this.selectedFileObjectsEdit[i] !== undefined) {
            formdata.append("ImageFileUrl" + i, this.selectedFileObjectsEdit[i]);
            formdata.append("FileType" + i, this.selectedFileTypeEdit[i]);
          } else if (this.editPostFiles[i - 1].src !== null) {
            formdata.append("FileUrl" + i, this.editPostFiles[i - 1].src);
            formdata.append("FileType" + i, this.editPostFiles[i - 1].type);
          }

        }

        formdata.append("Latitude", this.markers[0].lat);
        formdata.append("Longitude", this.markers[0].lng);
        formdata.append("LocationTitle", this.locationName);
        let tags = this.editHashtags
        if (tags !== null && tags.length > 0) {
          for (let i = 0; i < tags.length; i++) {
            formdata.append("SelectedHashTags[" + i + "]", tags[i]);
          }
        }

        let productsId = this.editProductSelectedList
        if (productsId !== null && productsId.length > 0) {
          for (let i = 0; i < productsId.length; i++) {
            formdata.append("SelectedProducts[" + i + "]", productsId[i]);
          }
        }


        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        let resStatus = null
        fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/_Edit", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                this.resultText = JSON.parse(result).Message
                this.editDialog = false
                location.reload()
              } else {
                this.resultText = result
              }
              this.loading = false
              this.showResult = true
            })
            .catch(error => console.log('error', error));
      } else {
        this.resultText = 'عکس کاور پست خود را وارد کنید'
        this.showResult = true
      }
    },
    closeEditDialog() {
      this.editCaptionEditor.destroy()
      this.editDialog = false
    },
    changeActivePost(id, item) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", id);
      if (item.IsActive) {
        urlencoded.append("isActive", false);
      } else {
        urlencoded.append("isActive", true);
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/SetPostActiveStatus", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getPosts()
          })
          .catch(error => console.log('error', error));
    },
    removeDefinePostFields() {
      this.getPosts()
      this.selectedImageCoverFilePath = null
      this.coverEditImage = null
      this.captionEditor = new Editor({
        content: '',
      })
      if (this.selectedFileObjects[1] !== undefined) {
        delete this.selectedFileObjects[1]
        delete this.selectedFileType[1]
        document.getElementById('image' + 1).style.backgroundImage = null

      }
      if (this.selectedFileObjects[2] !== undefined) {
        delete this.selectedFileObjects[2]
        delete this.selectedFileType[2]
        document.getElementById('image' + 2).style.backgroundImage = null

      }
      if (this.selectedFileObjects[3] !== undefined) {
        delete this.selectedFileObjects[3]
        delete this.selectedFileType[3]
        document.getElementById('image' + 3).style.backgroundImage = null

      }
      if (this.selectedFileObjects[4] !== undefined) {
        delete this.selectedFileObjects[4]
        delete this.selectedFileType[4]
        document.getElementById('image' + 4).style.backgroundImage = null

      }
      if (this.selectedFileObjects[5] !== undefined) {
        delete this.selectedFileObjects[5]
        delete this.selectedFileType[5]
        document.getElementById('image' + 5).style.backgroundImage = null

      }
      if (this.selectedFileObjects[6] !== undefined) {
        delete this.selectedFileObjects[6]
        delete this.selectedFileType[6]
        document.getElementById('image' + 6).style.backgroundImage = null

      }
      if (this.selectedFileObjects[7] !== undefined) {
        delete this.selectedFileObjects[7]
        delete this.selectedFileType[7]
        document.getElementById('image' + 7).style.backgroundImage = null

      }
      if (this.selectedFileObjects[8] !== undefined) {
        delete this.selectedFileObjects[8]
        delete this.selectedFileType[8]
        document.getElementById('image' + 8).style.backgroundImage = null

      }
      if (this.selectedFileObjects[9] !== undefined) {
        delete this.selectedFileObjects[9]
        delete this.selectedFileType[9]
        document.getElementById('image' + 9).style.backgroundImage = null

      }
      this.getCurrentLocation()
      this.hashtags = []
      this.productSelectedList = []
      this.hasPhoto = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false
      }
      this.hasCoverPhoto = false
      document.getElementById('coverImage').style.backgroundImage = null
      document.getElementById('autocomplete').value = null;
      this.showListPostsTab()

    },
    searchInPostList() {
      let allPosts = this.allPostList
      let result =[]
      for(let i =0; i<allPosts.length ;i++){
        if(allPosts[i].SelectedHashTags !== null) {
          let find = allPosts[i].SelectedHashTags.find(x => x === this.searchKeyWord)
          if (find !== undefined) {
            result.push(allPosts[i])
          }
        }
      }
      if (this.searchKeyWord === '' || this.searchKeyWord === null) {
        this.postsItems = this.allPostList
        this.hasResult = true
      } else {
        if (result.length === 0) {
          this.hasResult = false
        } else {

          this.postsItems = result
        }
      }

    },
    removeSearchHistory() {
      this.searchKeyWord = null
      this.postsItems = this.allPostList
      this.hasResult = true
    },


  },


}
</script>

<style scoped>

</style>
